import React, { useEffect, useState } from "react";

//UI Material
import { Button, CircularProgress, Grid, Stack } from "@mui/material";

//Helpers
import { typographyForText } from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import Selector from "../basics/Selector";
import TaskCard from "./TaskCard";
import TaskDrawer from "../drawers/TaskDrawer";
import ErrorBox from "../ErrorBox";

//Material Icons
import { Add } from "@mui/icons-material";

const filterBy = ["Pendientes", "Finalizadas", "Canceladas", "Todas"];

export default function AdministratorSpace() {
  // ==========>Component States<==========
  //State for loading users
  const [loadingUsers, setLoadingUsers] = useState(true);
  //State for setting loader for tasks data
  const [dataLoader, setDataLoader] = useState(true);
  //State for setting error when could not get orders data
  const [dataError, setDataError] = useState(false);
  //State to handle tasks status filter
  const [userSelection, setUserSelection] = useState(0);
  //State for tasks
  const [tasks, setTasks] = useState([]);
  //State for open the drawer component with the select button
  const [drawerOpen, setDrawerOpen] = useState(false);
  //State to handle tasks status filter
  const [taskStatus, setTaskStatus] = useState(0);
  //State for users list
  const [usersList, setUsersList] = useState([]);

  let usersArray = usersList.map((u) => u.user);
  let selectedUser = usersList.find((u) => u.user === usersArray[userSelection])

  // ==========>Component Functions<==========
  //Function to get users list
  const getUsersList = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(`/users/get`, {
        howMany: 500,
      });
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setUsersList(jsonResponse.data);
        getUserTasks();
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(true);
    }
    setLoadingUsers(false);
  };

  //Function to filer data
  const filteredTasks = () => {
    switch (taskStatus) {
      case 0:
        return tasks.filter((task) => !task.completed && !task.canceled);
      case 1:
        return tasks.filter((task) => task.completed && !task.canceled);
      case 2:
        return tasks.filter((task) => task.canceled);
      default:
        return tasks;
    }
  };

  //Function to check if there are tasks in user's account
  const checkForTasksLength = () => {
    if (!tasks.length) {
      return (
        <Grid item xs={12} align="center">
          {typographyForText("Aún no tienes tareas asignadas.")}
        </Grid>
      );
    } else {
      return generateTasks();
    }
  };

  //Function to select page component according to loading status
  const displayRequestedData = () => {
    if (dataLoader) {
      return (
        <Grid item xs={12} align="center">
          <CircularProgress />
        </Grid>
      );
    } else {
      return checkForTasksLength();
    }
  };

  //Function to get user's tasks
  const getUserTasks = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/tasks/get-user-tasks`,
        { userId: usersList[userSelection].email }
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setTasks(
          jsonResponse.data.sort((a, b) => {
            if (a.canceled && !b.canceled) {
              return 1; // Coloca "a" después de "b"
            } else if (!a.canceled && b.canceled) {
              return -1; // Coloca "a" antes de "b"
            } else if (a.completed && !b.completed) {
              return 1; // Coloca "a" después de "b"
            } else if (!a.completed && b.completed) {
              return -1; // Coloca "a" antes de "b"
            } else {
              return new Date(a.dueDate) - new Date(b.dueDate); // Ordenamiento por fecha
            }
          })
        );
      } else {
        if (requestResponse.status === 401) {
          window.alert("estuve aqui", usersList[userSelection].email)
          window.location.href = "/";
        }
      }
    } catch (e) {}
    setDataLoader(false);
  };

  useEffect(() => {
    getUsersList();
  }, []);

  //The useEffect checks for token validation
  useEffect(() => {
    getUserTasks();
  }, [userSelection]);

  //Function to generate tasks
  const generateTasks = () => {
    let myTasks = [];

    for (const task of filteredTasks()) {
      myTasks.push(
        <Grid item key={task.taskNumber} xs={12} sm={6} md={4} lg={3}>
          <TaskCard task={task} getTasks={getUserTasks} />
        </Grid>
      );
    }

    return !myTasks.length ? (
      <Grid item xs={12}>
        {typographyForText(
          `No hay tareas ${filterBy[taskStatus].toLowerCase()}.`
        )}
      </Grid>
    ) : (
      myTasks
    );
  };

  //Function to generate the whole component
  const generateTasksComponent = () => {
    if (loadingUsers) {
      return (
        <Stack alignItems="center">
          <CircularProgress />
        </Stack>
      );
    } else {
      return (
        <Grid container spacing={1} textAlign="center">
          <TaskDrawer
            open={drawerOpen}
            setOpen={setDrawerOpen}
            user={selectedUser.email}
            getData={getUserTasks}
          />
          <Grid item xs={12} align="center">
            <Stack direction="row" spacing={1} justifyContent="center">
              <Selector
                width="200px"
                value={userSelection}
                handleChange={(e) => {
                  setUserSelection(e.target.value);
                }}
                content={usersArray}
              />
              <Selector
                value={taskStatus}
                handleChange={(e) => {
                  setTaskStatus(e.target.value);
                }}
                content={filterBy}
              />
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Button
              startIcon={<Add />}
              color="secondary"
              size="small"
              onClick={() => {
                setDrawerOpen(true);
              }}
            >
              Nueva tarea
            </Button>
          </Grid>
          {displayRequestedData()}
        </Grid>
      );
    }
  };
  // ==========>Component<==========
  return dataError ? <ErrorBox /> : generateTasksComponent();
}
